<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="500"
      scrollable
    >
      <v-card>
        <v-toolbar color="primary" flat>
          <v-toolbar-title class="text--contrast">Условия использования</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn class="text--contrast"
                   icon
                   @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text v-html="UISettings.useTerms" id="use-terms"
                     class="black--text show-scrollbar pt-4 pb-2 pb-sm-4">
        </v-card-text>
        <v-card-actions class="align-center justify-center flex-wrap">
          <v-btn text @click="dialog = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'UseTermsDialog',
  props: ['value'],
  data: () => ({}),
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    ...mapGetters(['UISettings']),
  },
};
</script>

<style scoped>
#use-terms img {
  max-width: 400px;
}

.ql-video-wrapper {
  max-width: 600px;
}
</style>
